import { render, staticRenderFns } from "./channelManagement.vue?vue&type=template&id=9bf85010&scoped=true&"
import script from "./channelManagement.vue?vue&type=script&lang=js&"
export * from "./channelManagement.vue?vue&type=script&lang=js&"
import style0 from "./channelManagement.vue?vue&type=style&index=0&id=9bf85010&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf85010",
  null
  
)

export default component.exports